export default __webpack_public_path__ + "static/media/examreportimg.bd08372f.svg";